import { render } from "./BlackOil.vue?vue&type=template&id=3aaf749a"
import script from "./BlackOil.vue?vue&type=script&lang=js"
export * from "./BlackOil.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__